// Copyright (c) 2023 by Move Closer.

import { mapModel, MappingConfig, MappingTypes } from '@movecloser/front-core'

import { userAdapterMap } from './user.adapter'

/**
 * @author Filip Rurak <filip.rurak@movecloser.pl>
 */
export const companyAdapterMap: MappingConfig = {
  companyAdmin: {
    type: MappingTypes.Function,
    value: (item) => {
      return {
        ...mapModel(item.company_admin, userAdapterMap, false)
      }
    }
  },
  email: 'email',
  id: 'id',
  legalAddress: {
    type: MappingTypes.Function,
    value: (item) => {
      return {
        street: item.legal_address.street,
        city: item.legal_address.city,
        postCode: item.legal_address.postcode,
        countryCode: item.legal_address.country_code,
        telephone: item.legal_address.telephone,
        region: {
          name: item.legal_address.region.region,
          code: item.legal_address.region.region_code,
          id: item.legal_address.region.region_id
        }
      }
    }
  },
  legalName: 'legal_name',
  name: 'name',
  vatTaxId: 'vat_tax_id'
}
